export default __webpack_public_path__ + "static/media/logo-dark.ece10d9c.png";